var Exception;
(function (Exception) {
    Exception["AccessDenied"] = "AccessDenied";
    Exception["InvalidDetails"] = "InvalidDetails";
    Exception["InvalidInput"] = "InvalidInput";
    Exception["NotFound"] = "NotFound";
    Exception["RefreshTokenExpired"] = "RefreshTokenExpired";
    Exception["TokenExpired"] = "TokenExpired";
    Exception["UnknownError"] = "UnknownError";
    Exception["UnprocessableEntity"] = "UnprocessableEntity";
})(Exception || (Exception = {}));
export default Exception;
//# sourceMappingURL=exception.js.map